import type { ListingDetails } from 'app/types/listingDetails.type';
import { useDetailPanel } from '../../../ui/DetailPanel';
import { TourSpoke } from './TourSpoke';

export const TourSpokeContent = ({ config }: { config?: unknown }) => {
  const { closePanel } = useDetailPanel();
  const { listing, isModifyingTour } =
    (config as { listing?: ListingDetails; isModifyingTour?: boolean } | undefined) ?? {};

  return <TourSpoke onClose={closePanel} listing={listing} isModifyingTour={isModifyingTour} />;
};
